import i18n from '@/i18n';
import { formatGMTDateToJavascriptDate } from '@/business/utils/dates';

function addSlash(text) {
  return text && `${text.slice(0, 2)}/${text.slice(2, 4)}`;
}

const treatCurrentResponse = (response) => {
  const property = response.data.items[0];

  return {
    ...property,
    entity: `${property.entity_id} - ${property.entity_name}`,
    address: `${property.location_street_number ||
      ''} ${property.location_street_name || ''}
        ${property.location_post_code || ''} ${property.location_city ||
      ''}${property.location_country || ''}`,

    energy_management: {
      ...property.energy_management,
      technician_affected: property.energy_management
        .technician_affected_firstname
        ? `${property.energy_management.technician_affected_firstname} ${property.energy_management.technician_affected_lastname}`
        : '',
      maintenance_shutdown_period:
        property.energy_management.maintenance_start_shutdown &&
        i18n.t('message.boilerplate.filters.fromTo', {
          dateMin: property.energy_management.maintenance_start_shutdown,
          dateMax: property.energy_management.maintenance_end_shutdown,
        }),
    },
    energetic_efficiency: {
      ...property.energetic_efficiency,
      heating_period:
        property.energetic_efficiency.heating_start_datetime &&
        i18n.t('message.boilerplate.filters.fromTo', {
          dateMin: addSlash(
            property.energetic_efficiency.heating_start_datetime
          ),
          dateMax: addSlash(property.energetic_efficiency.heating_end_datetime),
        }),
    },
    reduced_temperature:
      property.energetic_efficiency.reduced_temperature &&
      `${i18n.t('message.boilerplate.units.temperature', {
        number: property.energetic_efficiency.reduced_temperature,
      })} ${i18n.t('message.boilerplate.filters.fromToHours', {
        min: property.energetic_efficiency.reduced_temperature_starttime,
        max: property.energetic_efficiency.reduced_temperature_endtime,
      })}`,
    contractual_commitment: {
      ...property.contractual_commitment,
      contract_startdate: formatGMTDateToJavascriptDate(
        property.contractual_commitment.contract_startdate
      ),
      contract_enddate: formatGMTDateToJavascriptDate(
        property.contractual_commitment.contract_enddate
      ),
    },
    usage: {
      ...property.usage,
      sizing_lib: `${(property.usage && property.usage.sizing) ||
        ''} ${(property.usage && property.usage.sizing_name) || ''}`,
    },
  };
};

export default treatCurrentResponse;
